import { commonHelper } from './common-helper'
export class ApiManager {
  constructor() { }

  async get(url, isSlient) {
    return await this.call('get', url, null, isSlient);
  }

  async post(url, request) {
    return await this.call('post', url, request);
  }

  async put(url, request) {
    return await this.call('put', url, request);
  }

  async delete(url, request) {
    return await this.call('delete', url, request);
  }

  async call(methodType, url, request, isSlient) {
    if (!isSlient) {
      commonHelper.showLoading();
    }
  
    return await window.$axios({
      method: methodType,
      url: url,
      data: request
    }).then(function (response) {
      commonHelper.hideLoading();
      return response.data;
    }).catch(this.handleError)
  }

  async handleError(error) {
    commonHelper.hideLoading();
    if (error && error.response && error.response.data && error.response.data.error) {
      console.log(error.response.data.error.message);
    }
    return Promise.resolve();
  }
}